import styled from 'styled-components';
import { KeywordsStyled } from '../KeywordsStyled';

export const KeywordsStyledAP = styled(KeywordsStyled)`
`;
